function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".dk_svg__cls-2{fill:#cf0b31}"));

var _ref2 = /*#__PURE__*/React.createElement("circle", {
  cx: 10,
  cy: 10,
  r: 10,
  fill: "#f0f0f0"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  className: "dk_svg__cls-2",
  d: "M7 9V.46A10 10 0 00.05 9zM9 9h11a10 10 0 00-10-9c-.34 0-.67 0-1 .05zM7 11H.05a10 10 0 007 8.54zM9 11v9c.33 0 .66.05 1 .05a10 10 0 0010-9z"
});

function SvgDk(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "dk_svg__Capa_1",
    "data-name": "Capa 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20"
  }, props), _ref, _ref2, _ref3);
}

export default "data:image/svg+xml;base64,PHN2ZyBpZD0iQ2FwYV8xIiBkYXRhLW5hbWU9IkNhcGEgMSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB2aWV3Qm94PSIwIDAgMjAgMjAiPjxkZWZzPjxzdHlsZT4uY2xzLTF7ZmlsbDojZjBmMGYwO30uY2xzLTJ7ZmlsbDojY2YwYjMxO308L3N0eWxlPjwvZGVmcz48Y2lyY2xlIGNsYXNzPSJjbHMtMSIgY3g9IjEwIiBjeT0iMTAiIHI9IjEwIi8+PHBhdGggY2xhc3M9ImNscy0yIiBkPSJNNyw5Vi40NkExMCwxMCwwLDAsMCwuMDUsOVoiLz48cGF0aCBjbGFzcz0iY2xzLTIiIGQ9Ik05LDlIMjBBMTAsMTAsMCwwLDAsMTAsMGMtLjM0LDAtLjY3LDAtMSwuMDVaIi8+PHBhdGggY2xhc3M9ImNscy0yIiBkPSJNNywxMUguMDVhMTAsMTAsMCwwLDAsNyw4LjU0WiIvPjxwYXRoIGNsYXNzPSJjbHMtMiIgZD0iTTksMTF2OWMuMzMsMCwuNjYuMDUsMSwuMDVhMTAsMTAsMCwwLDAsMTAtOVoiLz48L3N2Zz4=";
export { SvgDk as ReactComponent };